import React from 'react';

import { number, string, bool } from 'prop-types';

import { useTranslate } from '../../translate/I18n';

import Box from '../atoms/Box';
import ProgressionBar from '../atoms/ProgressionBar';
import Text from '../atoms/Text';

const MatchingPercentage = ({ percentage, flexDirection, hasLabel, label }) => {
  const { t } = useTranslate(['common']);
  return (
    <Box
      display="flex"
      flex="1"
      flexDirection={flexDirection}
      alignItems={flexDirection === 'column' ? 'start' : 'center'}
      data-cy="matching-percentage">
      {hasLabel && (
        <Text styleName="wPTiny" textAlign="right" mr={2}>
          {!label ? t('common:matching') : label}
        </Text>
      )}
      <Box display="flex" flex="1" alignItems="center">
        <ProgressionBar percentage={percentage} data-cy="matching-width" />
        <Text styleName="wPTiny" textAlign="right" ml={2}>
          {percentage}%
        </Text>
      </Box>
    </Box>
  );
};

MatchingPercentage.propTypes = {
  percentage: number,
  flexDirection: string,
  minWidth: string,
  label: string,
  hasLabel: bool
};

MatchingPercentage.defaultProps = {
  percentage: 0,
  flexDirection: 'row',
  minWidth: '0',
  hasLabel: true
};

export default MatchingPercentage;
